import { useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const PasswordField = ({ ...props }) => {
	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => setShowPassword((show) => !show);

	const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
	};

	const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
	};

	return (
		<TextField
			type={showPassword ? 'text' : 'password'}
			InputProps={{
				endAdornment: (
					<InputAdornment position='end'>
						<IconButton
							size='small'
							aria-label={showPassword ? 'hide the password' : 'display the password'}
							onClick={handleClickShowPassword}
							onMouseDown={handleMouseDownPassword}
							onMouseUp={handleMouseUpPassword}
							edge='end'
						>
							{showPassword ? <VisibilityOff /> : <Visibility />}
						</IconButton>
					</InputAdornment>
				),
			}}
			// slotProps={{
			// 	input: {
			// 		endAdornment: (
			// 			<InputAdornment position='end'>
			// 				<IconButton
			// 					aria-label={
			// 						showPassword ? 'hide the password' : 'display the password'
			// 					}
			// 					onClick={handleClickShowPassword}
			// 					onMouseDown={handleMouseDownPassword}
			// 					onMouseUp={handleMouseUpPassword}
			// 					edge='end'
			// 				>
			// 					{showPassword ? <VisibilityOff /> : <Visibility />}
			// 				</IconButton>
			// 			</InputAdornment>
			// 		),
			// 	},
			// }}
			{...props}
		/>
	);
};

export default PasswordField;
